import { Shimmer } from '@components/Shimmer/Shimmer';
import { StyledDiv } from '@pages/Products/components/AddEquipmentModal/components/FindBody/FindBody.styles';
import {
  StyledDivLoadingHeadings,
  StyledDivLoadingRows,
} from './DocumentsBody.styles';

function DocumentsLoadingCells(props: { height?: number; count: number }) {
  const { height, count } = props;

  return (
    <>
      {Array.from({ length: count }, (_, index) => {
        return (
          <Shimmer
            key={index}
            style={{ height, width: '100%', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        );
      })}
    </>
  );
}

export function DocumentsLoading() {
  return (
    <div>
      <StyledDiv>
        <StyledDivLoadingHeadings>
          <DocumentsLoadingCells height={18} count={5} />
        </StyledDivLoadingHeadings>
        <StyledDivLoadingRows>
          <DocumentsLoadingCells height={44} count={3} />
        </StyledDivLoadingRows>
      </StyledDiv>
    </div>
  );
}
